<template>
    <div>
        <div id="main_captical"></div>
    </div>
</template>

<script>
    import * as echarts from 'echarts'
    export default {
        props:{
            s:{
                type: Number,
                default: 0 ,
            },
            m:{
                type: Number,
                default: 0,
            },
            l:{
                type: Number,
                default: 0,
            },
            xl:{
                type: Number,
                default: 0,
            },
        },
        mounted(){
            this.main_captical();//传值之后再渲染
        },
        watch:{
            s:{
                handler(val, oldVal){
                    if(typeof val == "number"){
                        this.main_captical();//传值之后再渲染
                    }
                },
                deep:true //true 深度监听
            }
        },
        methods:{
            main_captical(){
                var myChart = echarts.init(document.getElementById('main_captical'));
                function fontSize(res){
                    let docEl = document.documentElement,
                        clientWidth = window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth;
                    if (!clientWidth) return;
                    let fontSize = (clientWidth / 750);
                    return res*fontSize;

                }
                var option = {

                    // ---  提示框 ----
                    tooltip: {
                        show: true,   // 是否显示提示框，默认为true
                        trigger: 'item', // 数据项图形触发
                        textStyle: {
                            color: '#333333',
                            fontSize:fontSize(22),
                        },
                        backgroundColor:'#FFFBFB',	//tooltip背景色
                        borderColor:'#FFA391',		//tooltip边框颜色
                        borderWidth:3,
                        formatter: function (param) {	//自定义tooltip内容
                            var text = '';
                            //console.log(param)
                            var data = param.data;
                            if(param.data < 0) data = -param.data;
                            text += '<div class="tooltip">' +
                                '<div>'+param.name+':'+(data/10000).toFixed(2)+'万</div>' +
                                '</div>'
                            return text;
                        }
                    },
                    //  ------  X轴 ------
                    xAxis: {
                        show: true,  // 是否显示
                        position: 'bottom',  // x轴的位置
                        offset: 0, // x轴相对于默认位置的偏移
                        type: 'category',   // 轴类型， 默认为 'category'
                        name: '',    // 轴名称
                        axisLine: {       // 坐标轴 轴线
                            show: true,  // 是否显示
                            symbol: ['none', 'none'],  // 是否显示轴线箭头
                        },
                        axisTick: {    // 坐标轴 刻度
                            show: false,  // 是否显示
                        },
                        axisLabel: {    // 坐标轴标签
                            show: true,  // 是否显示
                            inside: false, // 是否朝内
                            rotate: 0, // 旋转角度
                            margin: 5, // 刻度标签与轴线之间的距离
                            color: '#939393',  // 默认取轴线的颜色
                            fontSize:fontSize(22)
                        },
                        splitLine: {    // gird区域中的分割线
                            show: false,  // 是否显示
                            lineStyle: {

                            }
                        },
                        splitArea: {    // 网格区域
                            show: false  // 是否显示，默认为false
                        },
                        data: ['超大单', '大单', '中单', '小单']
                    },
                    //   ------   y轴  ----------
                    yAxis: {
                        show: false,  // 是否显示
                    },
                    grid:{
                        //top:0,
                        x:0,
                        y:40,
                        x2:0,
                        y2:40,
                    },
                    //  -------   内容数据 -------
                    series: [
                        {
                            name: '',      // 序列名称
                            type: 'bar',      // 类型
                            legendHoverLink: true,  // 是否启用图列 hover 时的联动高亮
                            label: {   // 图形上的文本标签
                                show: true,
                                position:'top',
                                distance:5,
                                formatter: function(params) {
                                    //console.log(params)
                                    if (params.data > 0) {
                                        return "{one|" + (params.data/10000).toFixed(2)+'万' + "}";
                                    }
                                    else if(params.data < 0){
                                        return "{two|" + (-params.data/10000).toFixed(2)+'万' + "}";
                                    }
                                    else{
                                        return "{zero|" + '0.00万' + "}";
                                    }
                                },
                                rich: {
                                    one: {
                                        color: "#FE484A",
                                        fontSize:fontSize(20),
                                    },
                                    two: {
                                        color: "#448DFE",
                                        fontSize:fontSize(20),
                                    },
                                    zero:{
                                        color: "#939393",
                                        fontSize:fontSize(20),
                                    }
                                },
                            },
                            itemStyle: {    // 图形的形状
                                normal: {
                                    color: function (data) {//设置正负颜色值
                                        return data.value>=0?"#FE484A":"#63A0FF";
                                    }
                                }
                            },
                            barWidth: '50%',  // 柱形的宽度
                            data: [this.xl, this.l, this.m, this.s]
                        }
                    ]
                }
                myChart.setOption(option);
            }
        }
    }
</script>

<style lang="scss" scoped>
    #main_captical{
        height: 5.3rem;
        width: 9.3rem;
    }
</style>